<template>
    <span @click="clickItem">
        <typo
            :class="`link ${open ? 'open' : ''} level-${item.level}`"
            name="body-12-normal"
            v-html="item.title"
        ></typo>
    </span>
</template>

<script>
import { isEmpty } from "lodash";
import scrollManager from "src/components/convention/managers/scrollManager";

export default {
    components: {},
    props: ["item", "open"],
    methods: {
        clickItem() {
            if (!isEmpty(this.item.key)) {
                scrollManager.scrollToId(this.item.key);
            }
        },
    },
};
</script>

<style scoped lang="sass"></style>
